import React, {useState} from "react";
import {InputGroup} from "react-bootstrap";
import {queryStringToHash, updateQueryString} from "./lib/utils";
import DatePicker from "./DatePicker";

const SearchDateRange = props => {
  const [start, setStart] = useState(props.start || '');
  const [end, setEnd] = useState(props.end || '');

  const fetch = (s, e) => {
    updateQueryString({[props.startName]: s || '', [props.endName]: e || ''});
  };

  const handleStartChange = (val) => {
    setStart(val);
    fetch(val, end);
  };

  const handleEndChange = (val) => {
    setEnd(val);
    fetch(start, val);
  };

  return (
    <InputGroup className="align-items-center">
      <DatePicker label={props.label + '(開始)'} value={start} onChange={handleStartChange} />
      <span className="mx-1">～</span>
      <DatePicker label={props.label + '(終了)'} value={end} onChange={handleEndChange} />
    </InputGroup>
  );
}

export default SearchDateRange;
